import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { coordinacionService } from '../services/coordinacionService';

export function useCohortes() {
  return useQuery({ queryKey: ['cohortes'], queryFn: coordinacionService.listCohortes });
}

export function useSetFechaCohorte() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: coordinacionService.setFecha,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['cohortes'] });
      qc.invalidateQueries({ queryKey: ['instancias'] }); // los procesos ahora tienen fecha
    },
  });
}
